import { createFileRoute } from "@tanstack/react-router";
import HgBreadcrumbs from "@/common/components/ui/atoms/HgBreadcrumbs";
import AdminPendingInvites from "@/common/components/views/AdminPendingInvites";
import { usePendingPermissions } from "@/pages/admin/pending";

export const Route = createFileRoute("/app/admin/pending/invites")({
  component: RouteComponent,
});

function RouteComponent() {
  const { userCanEditAllInvites, userCanViewAllInvites, userCanViewAllUsers } = usePendingPermissions();

  return (
    <>
      <HgBreadcrumbs
        options={[
          { title: "Admin", link: null, unlink: true },
          { title: "Pending Invites", link: null },
        ]}
      />
      <h1>Pending Invites</h1>
      <AdminPendingInvites
        userCanEditAllInvites={userCanEditAllInvites}
        userCanViewAllInvites={userCanViewAllInvites}
        userCanViewAllUsers={userCanViewAllUsers}
      />
    </>
  );
}
